module.exports = __webpack_public_path__ + "static/browser@2x-541ca0c7e0d03d2387a226f93979826b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/handoff/browser@2x.jpg
// module id = 2598
// module chunks = 168707334958949